import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";

const initialState = {
  updateCard: false,
};

const personalInfoSlice = createSlice({
  name: "updateProfileDetailCard",

  initialState,
  reducers: {
    updateCard: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      state = payload;
    },
    // resetPersonalInfo: (state: personalInfoType) => {
    //   state.firstName = "";
    //   state.lastName = "";
    //   state.DOB = new Date();
    //   state.gender = "";
    //   state.martialStatus = "";
    //   state.country = "";
    //   state.email = "";
    //   state.phone = "";
    // },
  },
});

export const { updateCard } = personalInfoSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default personalInfoSlice.reducer;
